import script from "./ExpandableImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandableImage.vue?vue&type=script&setup=true&lang=js"

import "./ExpandableImage.vue?vue&type=style&index=0&id=b93d6db0&lang=css"

const __exports__ = script;

export default __exports__